var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.5 16.5V13H11v5H6v-1.5zM16.5 16.5H13V18h5v-5h-1.5zM23.5 16.5H20V18h5v-5h-1.5zM30.5 16.5H27V18h5v-5h-1.5zM9.5 30.5H6V32h5v-5H9.5zM6 23.5h3.5V20H11v5H6zM16.5 30.5H13V32h5v-5h-1.5zM13 23.5h3.5V20H18v5h-5zM23.5 30.5H20V32h5v-5h-1.5zM20 23.5h3.5V20H25v5h-5zM30.5 30.5H27V32h5v-5h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M27 23.5h3.5V20H32v5h-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 6h26v5H6z"
  })));
};
export default SvgCalendar;